import { render, staticRenderFns } from "./ListSuppliesCompleted.vue?vue&type=template&id=1cb5e924"
import script from "./ListSuppliesCompleted.vue?vue&type=script&lang=js"
export * from "./ListSuppliesCompleted.vue?vue&type=script&lang=js"
import style0 from "./ListSuppliesCompleted.vue?vue&type=style&index=0&id=1cb5e924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports